import api from "../../Environment";

/**
 * Reverse Raffle public API client (read-only).
 * Live ticket purchase is intentionally not wired (Product/Legal gate).
 * Drawing order is server-authoritative — never shuffle client-side.
 */

function unwrap(response) {
  return response && response.data ? response.data : null;
}

function apiErrorMessage(error, fallback) {
  const body =
    error && error.response && error.response.data
      ? error.response.data
      : null;
  if (body && (body.error_message || body.error)) {
    return body.error_message || body.error;
  }
  return fallback;
}

export async function fetchReverseRaffleEvent(slug) {
  if (!slug) {
    return { event: null, error: true, message: "Event slug required." };
  }
  try {
    const body = unwrap(await api.postMethod("reverse_raffle/show", { slug }));
    if (body && body.success && body.data) {
      return { event: body.data, error: false, message: null };
    }
    return {
      event: null,
      error: true,
      message:
        (body && (body.error_message || body.error)) ||
        "We couldn’t load this Reverse Raffle event.",
    };
  } catch (e) {
    const status = e && e.response ? e.response.status : null;
    const message = apiErrorMessage(
      e,
      "We couldn’t load this Reverse Raffle event. Please try again."
    );
    return {
      event: null,
      error: true,
      message: status === 404 ? message || "Event not found" : message,
    };
  }
}

export async function fetchReverseRaffleList() {
  try {
    const body = unwrap(await api.postMethod("reverse_raffle/list", {}));
    if (body && body.success && Array.isArray(body.data)) {
      return { events: body.data, error: false, message: null };
    }
    return {
      events: [],
      error: true,
      message:
        (body && (body.error_message || body.error)) ||
        "We couldn’t load Reverse Raffle events.",
    };
  } catch (e) {
    return {
      events: [],
      error: true,
      message: apiErrorMessage(
        e,
        "We couldn’t load Reverse Raffle events. Please try again."
      ),
    };
  }
}
